import { render, staticRenderFns } from "./SessionsPage.vue?vue&type=template&id=5effbee1"
import script from "./SessionsPage.vue?vue&type=script&lang=js"
export * from "./SessionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports